import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  editMode: false,
};

const editModeSlice = createSlice({
  name: 'editMode',
  initialState,
  reducers: {
    setEditMode: (state, action) => {
      state.editMode = action?.payload;
    },
  },
});

export const { setEditMode } = editModeSlice.actions;
export default editModeSlice.reducer;
